import React from 'react';

export const LineHeight = () => (
    <g>
        <path d='M6.146,3.854C6.244,3.951,6.372,4,6.5,4s0.256-0.049,0.354-0.146c0.195-0.195,0.195-0.512,0-0.707L3.854,0.147
			C3.808,0.101,3.752,0.064,3.691,0.038c-0.123-0.05-0.26-0.05-0.383,0C3.248,0.064,3.192,0.101,3.146,0.147L0.146,3.146
			c-0.195,0.195-0.195,0.512,0,0.707s0.512,0.195,0.707,0L3,1.707v20.586l-2.146-2.146c-0.195-0.195-0.512-0.195-0.707,0
			s-0.195,0.512,0,0.707l2.999,2.999c0.047,0.047,0.103,0.083,0.163,0.109C3.37,23.986,3.435,24,3.5,24s0.13-0.014,0.191-0.038
			c0.061-0.026,0.116-0.062,0.163-0.109l2.999-2.999c0.195-0.195,0.195-0.512,0-0.707s-0.512-0.195-0.707,0L4,22.293V1.707
			L6.146,3.854z' />
        <path d='M12.5,1h11C23.776,1,24,0.776,24,0.5S23.776,0,23.5,0h-11C12.224,0,12,0.224,12,0.5S12.224,1,12.5,1z' />
        <path d='M23.5,3h-13C10.224,3,10,3.224,10,3.5S10.224,4,10.5,4h13C23.776,4,24,3.776,24,3.5S23.776,3,23.5,3z' />
        <path d='M23.5,6h-13C10.224,6,10,6.224,10,6.5S10.224,7,10.5,7h13C23.776,7,24,6.776,24,6.5S23.776,6,23.5,6z' />
        <path d='M23.5,9h-13C10.224,9,10,9.224,10,9.5s0.224,0.5,0.5,0.5h13c0.276,0,0.5-0.224,0.5-0.5S23.776,9,23.5,9z' />
        <path d='M23.5,15h-11c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h11c0.276,0,0.5-0.224,0.5-0.5S23.776,15,23.5,15z' />
        <path d='M23.5,18h-13c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h13c0.276,0,0.5-0.224,0.5-0.5S23.776,18,23.5,18z' />
        <path d='M23.5,21h-13c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h13c0.276,0,0.5-0.224,0.5-0.5S23.776,21,23.5,21z' />
    </g>
);